var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', [_c('div', [_c('el-radio-group', { attrs: { "size": "small" }, model: { value: _vm.type, callback: function callback($$v) {
        _vm.type = $$v;
      }, expression: "type" } }, [_c('el-radio-button', { attrs: { "label": "2" } }, [_vm._v("横屏")]), _vm._v(" "), _c('el-radio-button', { attrs: { "label": "1" } }, [_vm._v("竖屏")])], 1)], 1), _vm._v(" "), _c('preview-device', { ref: "device", staticClass: "preview-device", attrs: { "src": _vm.url, "orientation": +_vm.type, "dynamicZoom": false } })], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };